import * as screens from '@core/layouts/components/menu/screens';
import forms from 'views/screens/Forms/sidebarLayout';
import paths from 'views/screens/Jobs/paths';
import permissions from 'views/screens/Jobs/permissions';

export default [
  {
    id: 'jobsBacklog',
    title: 'jobs.backlog',
    iconName: 'Server',
    permissions: [permissions.listJobsBacklog],
    navLink: paths.backlog,
    screenId: screens.BACKLOG_JOBS
  },
  {
    id: 'ImportJobs',
    title: 'jobs.importJobs',
    iconName: 'UploadCloud',
    permissions: [permissions.jobsImport],
    navLink: paths.import,
    screenId: screens.IMPORT_JOBS
  },
  {
    id: 'jobsBoard',
    title: 'jobs.board',
    iconName: 'Trello',
    permissions: [permissions.jobsBoard],
    navLink: paths.board,
    screenId: screens.JOBS_BOARD
  },
  {
    id: 'jobsMonitor',
    title: 'jobs.monitor',
    iconName: 'Monitor',
    permissions: [permissions.jobsMonitor],
    navLink: paths.monitor,
    screenId: screens.JOBS_MONITOR
  },
  {
    id: 'jobsReport',
    title: 'jobs.report',
    iconName: 'Clock',
    permissions: [permissions.jobsReport],
    navLink: paths.report,
    screenId: screens.JOBS_REPORT
  },
  {
    id: 'workingActivityReport',
    title: 'jobs.reports.workingActivity',
    iconName: 'Calendar',
    permissions: [permissions.jobsWorkingActivity],
    navLink: paths.workingActivityReport,
    screenId: screens.JOBS_WORK_ACTIVITY
  },
  ...forms
];
